import { render } from "./EWShopDetail.vue?vue&type=template&id=84a3a122&scoped=true"
import script from "./EWShopDetail.vue?vue&type=script&lang=js"
export * from "./EWShopDetail.vue?vue&type=script&lang=js"

import "./EWShopDetail.vue?vue&type=style&index=0&id=84a3a122&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84a3a122"]])

export default __exports__